export default class AdivareDateFormatter {
  constructor(locale) {
    this.locale = locale;
    this.baseFormatter = this.createFormatter();
    this.apiFormatter = null;
  }

  format(date, options) {
    if ('string' === typeof date) {
      date = new Date(date);
    }

    if (!(date instanceof Date)) {
      throw new Error(`Unable to format provided date: ${date}`);
    }

    return this.getFormatter(options).format(date);
  }

  createFormatter(options) {
    return new Intl.DateTimeFormat(this.locale, options);
  }

  getFormatter(options) {
    if (undefined === options || null === options || [] === options || {} === options) {
      return this.baseFormatter;
    }
    return this.createFormatter(options);
  }
}

export const createDateFormatter = locale => new AdivareDateFormatter(locale);
